/****************************************************
 * Module Name:  userDocumentProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class UserDocumentProxy {
    static getAllUserDocuments = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/userdocument",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0)
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    }

    static getDocumentByUserID = (userId, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/userdocument/${userId}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0)
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    }

    static createUserDocument = (file, docid, userid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/userdocument/${docid}/${userid}`,
            "post",
            Constants.userToken,
            undefined,
            file,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static updateUserDocument = (file, docid, userid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/userdocument/${docid}/${userid}`,
            "put",
            Constants.userToken,
            undefined,
            file,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}